import clsx from "clsx";
import dynamic from "next/dynamic";
import React, { ReactNode } from "react";
import { Navigation } from "./Navigation";

const AgeVerificationDialog = dynamic(
  () => import("components/AgeVerificationDialog"),
  { ssr: false },
);

export interface LayoutProps {
  children?: ReactNode;
  className?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, className }) => {
  return (
    <div className={className}>
      <Navigation />
      <main className={clsx("mt-2", className)}>{children}</main>
      <AgeVerificationDialog />
    </div>
  );
};
